import { AVAILABLE, COLLECTED, COMPLETED } from '../../../../../constants/components/pages/challenges/statuses';

export const useChallengeStatus = (challenge) => {
  return (() => {
    if (challenge?.isCollected) return COLLECTED;
    if (challenge?.isComplete) return COMPLETED;
    if (challenge?.isAvailable) return AVAILABLE;
  })();
};
